import { sanitize } from "../TapiocaUtils";
export default class FormsClient {
  constructor(raw) {
    this.raw = raw;
  }
  getLibraryFieldReportTypes(projectUid, params) {
    const url = `/v7/project/${projectUid}/library/field-report-types`;
    return this.raw.get({ url, params: sanitize(params || {}, {}) });
  }
}
